import moment from "moment";

import { FETCH_ANOMALY_FAIL, FETCH_ANOMALY_SUCCESS, RESET_ANOMALY } from "../actionTypes/smartInsights";

const initialState = { data: [], error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ANOMALY_SUCCESS:
      return fetchSystemsSuccess(state, action);
    case FETCH_ANOMALY_FAIL:
      return fetchSystemsFail(state, action);
    case RESET_ANOMALY:
      return initialState;
    default:
      return state;
  }
};

function fetchSystemsSuccess(state, action) {
  const { data } = action.payload;
  data.sort((insight1, insight2) => moment(insight2.CycleStartTime).unix() - moment(insight1.CycleStartTime).unix());
  return { data, error: null };
}

function fetchSystemsFail(state, action) {
  return { ...state, error: action.payload.error.message };
}

export default reducer;
